import { ComponentStyleConfig } from "@chakra-ui/react";
import { SystemStyleObject } from "@chakra-ui/styled-system";

const baseStylesForColorScheme: Record<string, SystemStyleObject> = {
  primary: {
    fontWeight: "medium",
    color: "teal.700",
    textDecoration: "none",
    textDecorationColor: "teal.700",
    "*[data-currency-symbol]": {
      _after: {
        color: "teal.400 !important",
      },
    },
    _hover: {
      color: "teal.800",
      textDecoration: "underline",
    },
  },
  gray: {
    color: "gray.500",
    textDecoration: "underline",
    textDecorationColor: "gray.500",
    _hover: {
      color: "gray.700",
      textDecorationColor: "gray.700",
    },
  },
};

const LinkTheme: ComponentStyleConfig = {
  baseStyle: ({ colorScheme }) => ({
    ...baseStylesForColorScheme[colorScheme],
    textDecorationSkipInk: "none",
    "&.chakra-menu__menuitem": {
      textDecoration: "none",
      fontWeight: "normal",
    },
    _disabled: {
      "&:not(.chakra-button)": {
        opacity: 0.4,
      },
      pointerEvents: "none",
    },
    ".mb-link-icon-external": {
      display: "none",
    },
  }),
  variants: {
    tableCell: {
      color: "gray.600",
      textDecorationColor: "gray.600",
      _hover: {
        color: "gray.700",
        textDecorationColor: "gray.700",
      },
      _active: {
        color: "gray.900",
        textDecorationColor: "gray.900",
      },
    },
    tableRowHeader: {
      color: "inherit",
      textDecoration: "none",
      _hover: {
        textDecoration: "none",
        ".mb-value-content": {
          textDecorationColor: "primary.500",
          textDecoration: "underline",
        },
        ".mb-link-icon-external": {
          display: "inline-block",
        },
      },
    },
    tableCellAction: {
      ".mb-link-icon-external": {
        display: "inline-block",
      },
    },
    tableColumnHeader: {
      ".mb-cell-value-type-money &": {
        ".mb-header-cell-comp-title[data-currency-symbol]": {
          _after: {
            color: "primary.400",
          },
        },
      },
      ".mb-link-icon-external": {
        display: "inline-block",
      },
    },
    textButton: ({ colorScheme }) => {
      const stylesForColorScheme: Record<string, SystemStyleObject> = {
        gray: {
          _hover: {
            color: "gray.500",
          },
          _active: {
            color: "gray.700",
            bg: "gray.25",
          },
        },
      };
      return stylesForColorScheme[colorScheme];
    },
  },
  sizes: {
    default: {
      // fontSize/lineHeight inherited from the parent element style by default
      "& .chakra-icon": {
        width: "19px",
        height: "19px",
      },
    },
    xs: {
      fontSize: "10px",
      lineHeight: "16px",
      "& .chakra-icon": {
        width: "16px",
        height: "16px",
      },
    },
    sm: {
      fontSize: "12px",
      lineHeight: "19px",
      "& .chakra-icon": {
        width: "19px",
        height: "19px",
      },
    },
    md: {
      fontSize: "16px",
      lineHeight: "20px",
      "& .chakra-icon": {
        width: "20px",
        height: "20px",
      },
    },
    rowHeader: {
      fontSize: "14px",
      lineHeight: "19px",
      "& .chakra-icon": {
        width: "19px",
        height: "19px",
      },
    },
  },
  defaultProps: {
    colorScheme: "primary",
    size: "default",
  },
};

export default LinkTheme;
